export default {
  setSession(context, data) {
    localStorage.setItem('session', JSON.stringify(data))
    context.commit('setSession', data)
  },
  getSession(context) {
    const session = localStorage.getItem('session')
    if (session && typeof session === 'string' && session !== '') {
      const data = JSON.parse(session)
      context.commit('setSession', data)
    }
  },
  updateConsumer({ commit, state }, data) {
    const consumers = [...state.consumers]
    const consumers_update = consumers.map(consumer => (consumer.api === data.api ? consumer : data))
    commit('setMyConsumers', consumers_update)
  },
  rmKey(context) {
    localStorage.removeItem('session')
    context.commit('rmKey')
  },
  setMyConsumers(context, data) {
    context.commit('setMyConsumers', data)
  },
  setProduct(context, data) {
    context.commit('setProduct', data)
  },
  stopBanner(context) {
    context.commit('stopBanner')
  },
  setShopOndemand(context, data) {
    context.commit('setShopOndemand', data)
  }
}
